__turbopack_context__.v({
  "learnMoreButtons": "learnMore-module-scss-module__7T_O7a__learnMoreButtons",
  "learnMoreContainer": "learnMore-module-scss-module__7T_O7a__learnMoreContainer",
  "learnMoreDescription": "learnMore-module-scss-module__7T_O7a__learnMoreDescription",
});
